import { IAdminGlobalMessage } from '@interfaces/adminGlobalMessages';

export const validateForm = (values: IAdminGlobalMessage) => {
  const errors: Partial<Record<keyof IAdminGlobalMessage, string | boolean>> = {};

  if (!values.message) errors.message = true;
  if (!values.startDate) errors.startDate = true;
  if (!values.endDate) errors.endDate = true;

  return errors;
};
